import { render, staticRenderFns } from "./sensor.vue?vue&type=template&id=f2dc42fa&scoped=true&"
import script from "./sensor.vue?vue&type=script&lang=js&"
export * from "./sensor.vue?vue&type=script&lang=js&"
import style0 from "./sensor.vue?vue&type=style&index=0&id=f2dc42fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2dc42fa",
  null
  
)

export default component.exports